@let blok = block();
@let inf = loadParams();
@let link = $safeNavigationMigration(blok?.link);

@if (link?.url || link?.cached_url) {

    @switch (link?.linktype) {
        @case ('url') {
            <a [href]="sanitizedLink() | desanitizeSlash"
               [target]="$safeNavigationMigration(link?.target)"
               [rel]="link?.target === '_blank' ? 'noopener noreferrer' : undefined">
                <ng-container [ngTemplateOutlet]="image" />
            </a>
        }
        @case ('story') {
            <a [routerLink]="$safeNavigationMigration(link?.cached_url) | sbRouterLink | cachedUrlResolver"
               [fragment]="link?.anchor ? $safeNavigationMigration(link?.anchor) : undefined"
               [target]="$safeNavigationMigration(link?.target)"
               (click)="(link?.anchor) && scrollTo($safeNavigationMigration(link?.anchor))"
            >
                <ng-container [ngTemplateOutlet]="image" />
            </a>
        }
        @case ('asset') {
            <a [href]="sanitizedLink() | desanitizeSlash"
               [target]="$safeNavigationMigration(link?.target)">
                <ng-container [ngTemplateOutlet]="image" />
            </a>
        }
        @case ('email') {
            <a [href]="'mailto:' + sanitizedLink() | desanitizeSlash">
                <ng-container [ngTemplateOutlet]="image" />
            </a>
        }
    }
} @else {
    <ng-container [ngTemplateOutlet]="image" />
}

<ng-template #image>
    @if (inf?.width && inf?.height) {
        <img class="block"
             [ngClass]="classes()"
             [ngSrc]="blok.asset.filename"
             [sizes]="sizes()"
             [width]="$safeNavigationMigration(inf?.width)"
             [height]="$safeNavigationMigration(inf?.height)"
             [alt]="blok.isDecorative? '' : blok.customAltText || blok.asset.alt"
             [title]="blok.asset.title"
             [loaderParams]="inf || {}"
             [priority]="blok.priority"
        >
    }
</ng-template>
